<template>
    <div class="payagreement">
        <div class="title">《弘商法律云平台用户支付协议》</div>
        <div class="content">
一、概述

1.1 弘商法律云平台归弘商信息技术（深圳）有限公司（以下简称“弘商公司”）所有并由弘商公司负责运营。

1.2 “用户”是指愿意接受或实际上已经接受弘商公司提供的产品和服务的个人。

1.3 本协议是用户就购买弘商法律云平台收费产品和服务向弘商公司支付相关费用事宜所订立的有效合约。您通过网络页面点击确认或以其他方式选择接受本协议，即表示您与弘商公司已达成协议并同意接受本协议的全部约定内容。

1.4 在接受本协议之前，请您仔细阅读本协议的全部内容。如果您不同意本协议的任意内容，或者无法准确理解本协议任何条款的含义，请不要进行确认及后续操作。如果您对本协议的条款有疑问的，请通过各自服务提供者的客服渠道进行询问，其将向您解释条款内容。

1.5 您同意，弘商公司有权随时对本协议内容进行单方面的变更，并以在弘商法律云平台上公告的方式提前予以公布，无需另行单独通知您；若您在本协议内容公告变更生效后继续使用本服务的，表示您已充分阅读、理解并接受变更修改后的协议内容，也将遵循变更修改后的协议内容使用本服务；若您不同意变更修改后的协议内容，您应在变更生效前停止使用本服务。

二、资费政策

2.1 弘商公司在提供产品和服务时，可能会对部分产品和服务向用户收取一定的费用。在此情况下，弘商公司会在相关页面上做明确的提示。如用户拒绝支付该等费用，则不能使用相关的产品和服务。

2.2 对于弘商公司的收费产品和服务，用户可自主选择接受或拒绝该收费产品或服务，并保证在使用收费产品或服务时，将按照弘商公司的相关收费规定支付费用，如拒付或拖欠费用，弘商公司将有权停止该产品或服务，并依法追偿损失及赔偿。

2.3 弘商公司将有权决定并随时修改所提供的产品和服务的资费标准和收费方式（包括免费到收费的修改），弘商公司可能会就不同的产品和服务制定不同的资费标准和收费方式，也可能按照所提供的产品和服务的不同阶段确定不同的资费标准和收费方式；另外，弘商公司也可能不时地修改资费政策。弘商公司会将有关产品和服务的资费标准、收费方式、购买方式或其他有关资费政策的信息放置在该产品和服务相关网页的显著位置。

三、费用标准

3.1 一旦您购买了弘商法律云平台的收费产品和服务，即视为您认可该产品和服务标明之价格；您支付成功后，该产品和服务即可使用。

3.2 费用标准：具体每项产品和服务的费用标准以具体标价为准。

四、风险及责任

4.1 您须对自身在使用弘商法律云平台所提供的产品和服务时的一切行为、行动（不论是否故意）负全部责任。

4.2 您应自行负责妥善且正确地保管、使用、维护在弘商法律云平台申请取得的账户及账户密码。您应对您的账户密码采取必要和有效的保密措施。非弘商法律云平台原因致使您账户密码泄漏以及因您保管、使用、维护不当造成损失的，弘商法律云平台无须承担与此有关的任何责任。

4.3 您明确了解并同意，付费方式为代收费运营商托收的付款方式，您通过此种付费方式付费可能存在一定的商业风险（包括但不限于不法分子利用您账户或银行卡等有价卡等进行违法活动），该等风险均会给您造成相应的经济损失。为此，您同意弘商法律云平台在充分履行其在本协议项下全部义务及勤勉谨慎义务的前提下不对您的前述风险和损失承担任何责任；并且，弘商法律云平台不承担向不法分子追究侵权责任或者代其向您承担损失的任何责任和义务。

4.4 您对本协议条款及修改有任何异议，可自动放弃其资格，但不退还任何已缴纳的收费产品和服务的费用。

4.5您有违反本协议任何行为，导致任何第三方损害的，您应当独立承担责任；弘商法律云平台因此若遭受损失的，您也应当一并赔偿。

五、购买步骤及账户消费查询

5.1 对于具体购买操作步骤，弘商法律云平台会在相关页面上做每一步的明确提示。

5.2 费用支付：收费产品和服务的费用将在您点击购买之日按照收费产品和服务上的标示价格通过银行、支付宝、微信等第三方代收费的方式支付。

5.3 一旦您在弘商法律云平台购买收费产品和服务成功后，则弘商法律云平台将即时收取该收费产品和服务的费用，并不提供退费服务。

5.4 您可通过登录弘商法律云平台，进入"个人中心"的"我的设置"项下，点击"消费/充值记录"，免费查询相应的消费服务详情。

六、用户权利限制

您在使用本产品和服务时需遵守以下行为规范，包括但不限于：

6.1 对于您购买的收费产品和服务，您只可以私人使用，不得用于商业、盈利等用途。

6.2 您同意不会采用收费或免费的方式，全部或部分地在任何公开场合展示您购买的收费产品和服务，除非您的上述行为不会构成侵权。

6.3 当您购买、使用收费产品和服务时，禁止有下列情况发生：

6.3.1 用非法的方式或为了非法的目的使用已购买的收费产品和服务；

6.3.2 将您的弘商法律云平台账户有偿或无偿提供给任何第三人，并允许他通过您的账户使用非其付费购买的收费产品和服务。

6.3.3 将收费产品和服务复制、销售、出租或授权给任何第三方。

6.3.4 主动对弘商法律云平台用于保护其收费产品和服务的任何安全措施技术进行攻克、反向操作、更改、破坏或其他篡改，或协助他人进行上述行为。

6.3.5 通过非弘商法律云平台官方认可的方式获得收费许可，或者删除收费产品和服务上的任何所有权声明或标签。

七、变更及免责条款

7.1 弘商法律云平台对收费产品和服务的服务周期、购买价格保留随时变更的权利，而不需通知您。对于所有服务的中断或终止而造成的任何损失，弘商法律云平台无需对您或任何第三方承担任何责任。

7.2 鉴于网络服务的特殊性，您同意弘商法律云平台有权随时变更、中断或终止部分或全部的网络服务。弘商法律云平台保留随时修改或中断服务而不需通知您的权利，对于所有服务的中断或终止而造成的任何损失，弘商法律云平台无需对您或任何第三方承担任何责任。

7.3 对于因服务器的死机、网络的故障、数据库故障、软件升级、服务器维修、调整、升级等问题，或其他不可抗拒的事由，包括但不限于政府行为、自然灾害、黑客攻击等造成的服务中断和对您个人数据及资料造成的损失，弘商法律云平台不承担由此对您造成的任何损失或退还任何已缴纳的收费产品和服务的费用。

7.4 您购买的产品和服务使用期限中包含解决故障、服务器维修、调整、升级等所需用的合理时间，对上述情况所需用的时间弘商法律云平台不予补偿并保留解释权。

7.5 弘商法律云平台对任何直接、间接、偶然、特殊及继起的损害不负责任，不予赔偿。

7.6 您在使用弘商法律云平台所提供的产品和服务时，如遭受任何人身或财务的损失、损害或伤害，不论原因如何，弘商法律云平台均不负责任。由于您将个人密码告知他人或与他人共享注册账户，由此导致的任何个人资料泄露，本网站不负任何责任。

八、中断及终止服务

8.1 在某些特殊情况下，由于权利授权问题可能致使弘商法律云平台上某些收费产品和服务无法继续使用。在这种情况下，弘商法律云平台不能给您退费，可以根据不同情况用服务内容替换方式给您补偿。

8.2 如您违反本服务条款中的内容，弘商法律云平台有权在不通知您的情况下立即终止您已购买的所有产品和服务，以及取消您的弘商法律云平台账户和使用权限，但不退还任何已缴纳的收费服务费用。

九、其他

9.1您使用本服务即视为您已阅读并同意受本协议的约束。

9.2本协议签订地为深圳市福田区。

9.3本协议的成立、生效、履行、解释及纠纷解决，适用中华人民共和国大陆地区法律。

9.4若您和弘商法律云平台之间发生任何纠纷或争议，首先应友好协商解决；协商不成的，您同意将纠纷或争议向本协议签订地有管辖权的人民法院提起诉讼。

9.5本协议所有条款的标题仅为阅读方便，本身并无实际涵义，不能作为本协议涵义解释的依据。

9.6本协议条款无论因何种原因部分无效或不可执行，其余条款仍有效，对双方具有约束力。

9.7 本协议最终解释权归弘商公司所有。

（以下无正文）

                                                                                                                                                                                            弘商信息技术（深圳）有限公司
        </div>
    </div>
</template>

<script>
export default {
    name: 'userAgreement'
}
</script>



// WEBPACK FOOTER //
// src/components/agreement/payAgreement.vue